// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MMUjl","siteTransform":"styles_siteTransform__k4O2N","siteStatic":"styles_siteStatic__an-Az","main":"styles_main__T0rbV"};